module.exports = __webpack_public_path__ + "static/media/gh_16aae4351783_258.a00b8fa4.jpg";